import { BlockType, FieldGroupSchema, FieldRole, ImageFieldSchema, PlainTextFieldSchema } from './Types';
import { z } from 'zod';

export const PAGE_DESCIRPTION_NAME = 'pageDescription';
export const PAGE_TITLE_NAME = 'pageTitle';
export const FAVICON_NAME = 'favicon';
export enum HeadLayout {
  Standard = 'standard',
}
export const HeadLayoutSchema = z.nativeEnum(HeadLayout);

const HeaderPageDescriptionFieldSchema = PlainTextFieldSchema.extend({
  name: z.literal(PAGE_DESCIRPTION_NAME),
  role: z.literal(FieldRole.Head),
});

const HeaderFaviconFieldSchema = ImageFieldSchema.extend({
  name: z.literal(FAVICON_NAME),
  role: z.literal(FieldRole.Head),
});

const HeaderPageTitleFieldSchema = PlainTextFieldSchema.extend({
  name: z.literal(PAGE_TITLE_NAME),
  role: z.literal(FieldRole.Head),
});

export const HeadFieldSchema = z.discriminatedUnion('name', [
  HeaderPageDescriptionFieldSchema,
  HeaderFaviconFieldSchema,
  HeaderPageTitleFieldSchema,
]);

export type HeadField = z.infer<typeof HeadFieldSchema>;

export const HeadFieldGroupSchema = FieldGroupSchema.extend({
  fields: z.array(HeadFieldSchema),
});
export type HeadFieldGroup = z.infer<typeof HeadFieldGroupSchema>;

export const HeadBlockConfigSchema = z.object({
  options: z.record(z.string(), z.any()),
  type: z.literal(BlockType.Head),
  fieldGroups: z.tuple([HeadFieldGroupSchema]),
  version: z.literal(1),
});

export const HeadFieldsSchema = z.object({
  Head: HeadFieldSchema.optional(),
});
